<div class="loading-spinner" *ngIf="isLoading">
  <em class="cc-icon cc-icon-spinner" aria-busy="true" aria-live="polite"></em>
</div>

<div class="sm-flex sm-h-full sm-min-h-0 sm-flex-col sm-space-y-6" *ngIf="!isLoading">
  <div class="sm-flex sm-min-h-0 sm-flex-1 sm-flex-col">
    <div class="actions-container">
      <section *ngIf="hasCurrentOrSubFoldersToggle" class="sm-border-grey-9 sm-py-2 sm-px-1">
        <cc-state-toggle defaultValue="currentFolder" [theme]="userListToggleTheme">
          <cc-state-toggle-item
            data-test="current-folder-toggle"
            value="currentFolder"
            i18n
            (click)="switchFolderToggle(userListTabView.CurrentFolder)"
            >Current folder</cc-state-toggle-item
          >
          <cc-state-toggle-item
            data-test="sub-folder-toggle"
            value="subFolders"
            i18n
            (click)="switchFolderToggle(userListTabView.SubFolder)"
          >
            Sub folders
          </cc-state-toggle-item>
        </cc-state-toggle>
      </section>

      <cc-user-list-search-bar
        [(searchTerm)]="searchTerm"
        (searchTermChange)="onSearch()"
        *ngIf="!checkedUsers.activeUsers.size && !checkedUsers.pendingUsers.size"
      ></cc-user-list-search-bar>

      <div
        class="sm-flex sm-items-center sm-space-x-2"
        *ngIf="checkedUsers.activeUsers.size || checkedUsers.pendingUsers.size"
      >
        <button
          class="button-regular cc-btn-subtle-gray remove-user-button"
          *ngIf="canRemoveUser && !checkedUsers.activeUsers.has(currentUserId)"
          (click)="removeUsers()"
        >
          <i class="cc-icon cc-icon-delete sm-text-default-red" aria-hidden="true"></i>
          <span class="sm-text-sm sm-text-black">Remove</span>
        </button>
        <button
          class="button-regular cc-btn-subtle-gray edit-profile-button"
          *ngIf="canEditProfile && checkedUsers.activeUsers.size === 1 && !checkedUsers.pendingUsers.size"
          (click)="editProfile()"
        >
          <i class="cc-icon cc-icon-pencil" aria-hidden="true"></i>
          <span class="sm-text-sm sm-text-black">Edit</span>
        </button>
      </div>
    </div>

    <div class="user-list-table">
      <div class="table-body">
        <!-- PENDING USERS -->
        <div class="pending-users">
          <cc-users-table-header
            [tableHeaders]="defaultList.pendingUsers?.length ? pendingUsersTableHeaders : null"
            [showCheckbox]="canRemoveUser && sortedList.pendingUsers?.length"
            (checkAll)="onCheckAll(PendingUsers)"
            (sort)="onSort($event, PendingUsers)"
            [isChecked]="sortedList.pendingUsers?.length === checkedUsers.pendingUsers?.size"
            [sortingColumn]="sortingColumn[PendingUsers]"
            [currentSortOrder]="currentSortOrder[PendingUsers]"
            tableName="Pending Invites"
            class="sm-border-t sm-border-grey-3"
            [showPermissionHeader]="isCurrentFolderView"
          ></cc-users-table-header>
          <div
            class="pending-users-table-row"
            *ngIf="defaultList.pendingUsers?.length; else emptyPendingUsersList"
          >
            <ng-container *ngFor="let user of sortedList.pendingUsers; index as index">
              <cc-pending-users-table-row
                *ngIf="!user.isActivated"
                [user]="user"
                [userType]="userType"
                [index]="index"
                [canRemoveUser]="canRemoveUser"
                [(searchTerm)]="searchTerm"
                (check)="onCheck($event, PendingUsers)"
                [isChecked]="checkedUsers.pendingUsers.has(user.id)"
                [showPermissionToggle]="isCurrentFolderView"
                [permissionOptions]="permissionOptions"
                (onUpdatePermission)="onUpdatePermission.emit(user)"
                [canUpdateUserPermission]="canUpdateUserPermission"
              >
              </cc-pending-users-table-row>
            </ng-container>
            <ng-container *ngIf="defaultList.pendingUsers?.length && !sortedList.pendingUsers?.length">
              <div class="no-results-container">
                <div class="picture-container">
                  <img
                    src="/assets/images/user/no-results.svg"
                    alt="No results"
                    data-test="user-list-no-results"
                    class="sm-h-full sm-w-auto"
                  />
                  <p i18n>Oops! No results</p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- ACTIVE USERS -->
        <div class="active-users">
          <cc-users-table-header
            [tableHeaders]="defaultList.activeUsers?.length ? activeUsersTableHeaders : null"
            [showCheckbox]="canRemoveUser && sortedList.activeUsers?.length"
            (checkAll)="onCheckAll(ActiveUsers)"
            (sort)="onSort($event, ActiveUsers)"
            [isChecked]="sortedList.activeUsers.length === checkedUsers.activeUsers?.size"
            [sortingColumn]="sortingColumn[ActiveUsers]"
            [currentSortOrder]="currentSortOrder[ActiveUsers]"
            tableName="Active Users"
            [enableSorting]="true"
            class="sm-border-t sm-border-grey-3"
            [showPermissionHeader]="isCurrentFolderView"
          ></cc-users-table-header>
          <div class="active-users-rows" *ngIf="defaultList.activeUsers.length; else emptyActiveUsersList">
            <ng-container *ngFor="let user of sortedList.activeUsers; index as index">
              <cc-active-users-table-row
                *ngIf="user.isActivated"
                [user]="user"
                [index]="index"
                [isChecked]="checkedUsers.activeUsers.has(user.id)"
                [canRemoveUser]="canRemoveUser"
                [(searchTerm)]="searchTerm"
                (check)="onCheck($event, ActiveUsers)"
                [showPermissionToggle]="isCurrentFolderView"
                [permissionOptions]="permissionOptions"
                [canUpdateUserPermission]="canUpdateUserPermission"
                (onUpdatePermission)="onUpdatePermission.emit(user)"
              >
              </cc-active-users-table-row>
            </ng-container>
            <ng-container *ngIf="defaultList.activeUsers?.length && !sortedList.activeUsers?.length">
              <div class="no-results-container">
                <div class="picture-container">
                  <img
                    src="/assets/images/user/no-results.svg"
                    alt="No results"
                    data-test="user-list-no-results"
                    class="sm-h-full sm-w-auto"
                  />
                  <p i18n>Oops! No results</p>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #emptyActiveUsersList>
  <div class="empty-user-list-message">
    <span class="text-muted" i18n>
      {{ emptyUserListMessages[tabView]?.activeUsers }}
    </span>
  </div>
</ng-template>

<ng-template #emptyPendingUsersList>
  <div class="empty-user-list-message">
    <span class="text-muted" i18n>
      {{ emptyUserListMessages[tabView]?.pendingUsers }}
    </span>
  </div>
</ng-template>
